import React, { useState, useEffect } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import Slider from "react-slick";
import "./CustomerTestimonials.scss";
import moment from "moment/dist/moment";
import { useStaticQuery, graphql } from "gatsby";
import YouTube from '@u-wave/react-youtube';
import getVideoId from 'get-video-id';
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import {ImageModule} from "@Components/common/Image_Module";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const items = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.3
    }
  }
}

const CustomerTestimonials = (props) => {
  const data = useStaticQuery(graphql`
  query{
    glstrapi {
      testimonials(publicationState: LIVE, where: {Publish: true}) {
        id
        imagetransforms
        ggfx_results {
          id
          content_type
          transforms
          src_import_url
          src_cftle
          field
        }
        Name
        Date
        Publish
        Video_Url
        Image {
          alternativeText
          url
        }
    
      }
    }
  }
  `);

  const [testimonials, settestimonials] = useState(data.glstrapi?.testimonials)
  const [videoId, setVideoId] = useState('');
  const [showVideo, setShowVideo] = useState(false);
  const [videoindex, setVideoindex] = useState(null);
  const playVideo = (id, Embed_Video_URL) => {
    var videoid = getVideoId(Embed_Video_URL);
    setShowVideo(true)
    setVideoindex(id)
    setVideoId(videoid.id)
  }
  const closePlay = () => {
    setShowVideo(false)
    setVideoId('')
    setVideoindex(null)
  }
  const trackerVideo = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Video Play Btn',
      'formType': event,
      'formId': 'Video Play',
      'formName': 'Video',
      'formLabel': 'Video'
    });
  }
  const settings = {
    dots: false,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 9999,

      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  }

  return (
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.section
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <React.Fragment>
            <section className="CustomerTestimonials-section">

              <Container>
                <Row>
                  <Col md={6} lg={12} className="order-lg-1">
                    <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                      <h2>Customer Testimonials</h2>
                    </ScrollAnimation>
                  </Col>

                </Row>
                <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                  <Slider {...settings}>
                    {testimonials.map((item, index) => {
                      let processedImages = JSON.stringify({});
                      if (item?.imagetransforms?.Image_Transforms) {
                        processedImages = item.imagetransforms.Image_Transforms;
                      }
                      return (

                        <motion.div className="team-card" variants={items}>
                          {showVideo && videoindex === index && <div onClick={(e) => { closePlay(e) }} className="close-iframe-btn"></div>}
                          <div className="team-card-content">
                            <h6>{item.Name}</h6>
                            <span className="designation">{moment(item.Date).format('MMMM YYYY')}</span>
                          </div>
                          <div className="item-image-wrrapper img-hover-zoom">
                            {showVideo && videoindex === index &&
                              <YouTube
                                video={videoId}
                                autoplay
                                showRelatedVideos={false}
                                showInfo={false}
                                annotations={false}
                                onEnd={e => { closePlay(e) }}
                                modestBranding={1}
                                onPlaying={trackerVideo(item?.Name)}

                              />
                            }
                            {/* <picture>
                                <source media="(min-width:992px)" srcSet={item.Image?.url} />
                                <source media="(min-width:768px)" srcSet={item.Image?.url} />
                                <img src={item.Image?.url} alt={item.Image?.alternativeText} />
                                </picture> */}
                            <ImageModule ImageSrc={item.Image} attr={{ alt: item?.Name }} ggfx_results={item.ggfx_results} imagename="testimonials.Image.tailimg" strapi_id={item.id} />

                            {/* <ImageTransform imagesources={item.Image?.url} renderer="srcSet" imagename='testimonials.Image.tailimg'
                              attr={{ alt: item.Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={item.id} >

                            </ImageTransform> */}
                            {item.Video_Url &&
                              <span onClick={(e) => {
                                playVideo(index, item.Video_Url);
                              }} className="video-btn"><i class="icon-video"></i></span>
                            }
                          </div>
                        </motion.div>
                      )
                    })}
                  </Slider>
                </ScrollAnimation>
              </Container>
            </section>
          </React.Fragment>
        </motion.section>
      )}
    </InView>
  )
}

export default CustomerTestimonials;